// extracted by mini-css-extract-plugin
export default {"schemaList":"SchemaList_schemaList__EG2mH"};